import React, { Component } from 'react'
import '../css/BisharatMain.css';
import MemberDataService from '../services/MemberDataService';
import Tree from '../components/Tree/Tree';
import AuthService from "../services/AuthService";
import Login from '../pages/Login';
import translate from '../languages/translate';
export default class FamilyTree extends Component {

  state = {
    membersData: [],
    loading: true
  }



  componentDidMount() {
    this.refreshTree();
  }


  refreshTree = ()  => {
    const loggedInUser = AuthService.getCurrentUser();
    const whatRole = AuthService.getUserRole();
   if( !loggedInUser || (whatRole === ('USER')) ) {
     this.setState({ loading: false });
     return;
   }
   const { match: { params } } = this.props;
   const id = params.id;
   this.setState({ loading: true });
   MemberDataService.getMember(id)
     .then(res => {
       const membersData1 = res.data;
       this.setState({ membersData: [membersData1], loading: false });
     })
     .catch(() => {
       this.setState({ loading: false });
     });
  }


  render() {
const treeData = this.state.membersData;
const loggedInUser = AuthService.getCurrentUser();
const whatRole = AuthService.getUserRole();
    return (
      <div>
      { !loggedInUser || (whatRole === ('USER')) ?
      <div>
        <Login></Login>
      </div> :
      this.state.loading ? (
        <div className="family-tree-loading">
          <div className="family-tree-loading-spinner" />
          <p className="family-tree-loading-text">{translate("loading-family-tree")}</p>
        </div>
      ) : (
      <div className="tree-wrapper" >
        <div className="tree-wrap-it-over">
        <Tree data ={treeData}></Tree>
        </div>
      </div>
      )
      }
      </div>
    )
  }
}
